import { Icon } from '@chakra-ui/react';

export const CloseSmallIcon = (props: any) => (
  <Icon data-testid="close-small-icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M8.46458 15.5355L15.5356 8.46448"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.46458 8.46445L15.5356 15.5355"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);
